import { defineMessages } from 'react-intl';

const translations = {
  card: {
    title: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationDetails.title',
      defaultMessage: 'Information',
      description: 'title of the information section on the fulfilment location details view',
    },
    button: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
  fields: {
    name: {
      id: 'properties.name',
      defaultMessage: 'Name',
      description: 'label of the name property',
    },
    address: {
      id: 'properties.address',
      defaultMessage: 'Address',
      description: 'label of the address property',
    },
  },
};

export default defineMessages(translations);
